import React, { useEffect, Children, createElement } from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, FileText, AlertTriangle, CheckCircle, ChevronRight, DollarSign, Mail, XCircle, Phone } from 'lucide-react';
import { PhoneAnimation } from '../components/PhoneAnimation';
export function SalesPage() {
  // Meta Pixel: init + PageView on mount
  useEffect(() => {
    // Inject Meta Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '923286363476807');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript pixel fallback
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=923286363476807&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  const handlePurchaseClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Fire Meta Pixel AddToCart event
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart', {
        value: 6.39,
        currency: 'USD',
        content_name: '48-Hour Debt Freeze'
      });
    }
    // Redirect to purchase URL (replace with your actual checkout link)
    window.location.href = 'https://www.versastorex.com/cart/42036537327696:1';
  };
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  return <div className="min-h-screen bg-[#0a0a0f] text-[#f0f0f0] overflow-x-hidden font-inter selection:bg-[#c9a227] selection:text-black" data-id="element-9">
      {/* 1. STICKY TOP BANNER */}
      <div className="sticky top-0 z-50 bg-[#c9a227] text-black py-2 px-4 text-center font-bold text-sm md:text-base shadow-lg" data-id="element-10">
        <div className="max-w-4xl mx-auto flex justify-center items-center gap-2" data-id="element-11">
          <span className="hidden sm:inline" data-id="element-12">⚠️ LIMITED TIME:</span>
          <span data-id="element-13">Get The 48-Hour Debt Freeze for just $6.39</span>
          <a href="#pricing" className="underline hover:no-underline ml-2 flex items-center" data-id="element-14">
            GET INSTANT ACCESS <ChevronRight className="w-4 h-4" data-id="element-15" />
          </a>
        </div>
      </div>

      {/* 2. HERO SECTION */}
      <header className="relative min-h-[90vh] flex flex-col justify-center items-center px-4 py-16 text-center bg-[radial-gradient(circle_at_center,_#1a1a2e_0%,_#0a0a0f_100%)]" data-id="element-16">
        <motion.div initial="hidden" animate="visible" variants={staggerContainer} className="max-w-4xl mx-auto" data-id="element-17">
          <motion.div variants={fadeIn} className="mb-8" data-id="element-18">
            <PhoneAnimation data-id="element-19" />
          </motion.div>

          <motion.div variants={fadeIn} className="inline-block bg-[#dc2626] text-white px-4 py-1 rounded-sm font-bold text-sm tracking-widest mb-6 shadow-[0_0_15px_rgba(220,38,38,0.5)] uppercase" data-id="element-20">
            Federal Law Protects You
          </motion.div>

          <motion.h1 variants={fadeIn} className="text-6xl md:text-8xl lg:text-9xl font-bebas leading-[0.9] mb-4 text-white drop-shadow-2xl" data-id="element-21">
            Stop The Ringing.
            <br data-id="element-22" />
            <span className="text-[#c9a227]" data-id="element-23">Start The Silence.</span>
          </motion.h1>

          <motion.h2 variants={fadeIn} className="text-xl md:text-3xl text-[#c9a227] mb-8 font-medium tracking-wide" data-id="element-24">
            In 48 Hours Or Less — Guaranteed
          </motion.h2>

          <motion.p variants={fadeIn} className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-25">
            Debt collectors are counting on your fear. The{' '}
            <span className="text-white font-bold" data-id="element-26">48-Hour Debt Freeze</span>{' '}
            gives you the exact legal scripts to silence them forever — under
            threat of a{' '}
            <span className="text-[#dc2626] font-bold" data-id="element-27">
              $1,000 federal penalty
            </span>
            .
          </motion.p>

          <motion.div variants={fadeIn} data-id="element-28">
            <a href="#" onClick={handlePurchaseClick} className="group relative inline-flex items-center justify-center bg-[#c9a227] text-black text-xl md:text-2xl font-bebas tracking-wide py-4 px-12 rounded-sm hover:bg-[#d4b03a] transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(201,162,39,0.4)]" data-id="element-29">
              <span className="relative z-10 flex items-center gap-2" data-id="element-30">
                Start the Debt Freeze — $6.39 <Shield className="w-5 h-5" data-id="element-31" />
              </span>
              <div className="absolute inset-0 rounded-sm ring-2 ring-white/30 group-hover:ring-white/50 animate-pulse" data-id="element-32"></div>
            </a>
            <p className="mt-4 text-sm text-gray-400 flex items-center justify-center gap-2" data-id="element-33">
              <Lock className="w-3 h-3" data-id="element-34" /> Instant Digital Download · No
              Subscription · 30-Day Guarantee
            </p>
          </motion.div>
        </motion.div>
      </header>

      {/* 3. EMPATHY MIRROR SECTION */}
      <section className="py-20 px-4 bg-[#0a0a0f]" data-id="element-35">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="max-w-3xl mx-auto bg-[#111118] border-l-4 border-[#c9a227] p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-36">
          <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-37">
            <FileText className="w-32 h-32 text-[#c9a227]" data-id="element-38" />
          </div>

          <p className="text-[#c9a227] font-serif italic text-xl mb-6" data-id="element-39">
            Dear Friend,
          </p>

          <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-40">
            <p data-id="element-41">
              I know that feeling in the pit of your stomach. The phone vibrates
              on the nightstand at 8:01 AM. You don't recognize the area code.
              Your heart skips a beat. You don't answer. You can't answer.
            </p>
            <p data-id="element-42">
              Then comes the "Private Number" at lunch. Then the call to your
              workplace.
            </p>
            <p className="text-2xl font-bold text-white border-l-2 border-[#dc2626] pl-4 py-2 bg-[#dc2626]/10" data-id="element-43">
              <span className="text-[#dc2626]" data-id="element-44">They are hunting you.</span>
            </p>
            <p data-id="element-45">
              They want you stressed. They want you triggered. Because when
              you're scared, you make mistakes. You promise money you don't
              have. You admit to debts that might not even be legally yours.
            </p>
          </div>
        </motion.div>
      </section>

      {/* 4. TRUTH REVEAL SECTION */}
      <section className="py-20 px-4 bg-[#0f0f1a] border-y border-gray-900" data-id="element-46">
        <div className="max-w-5xl mx-auto" data-id="element-47">
          <div className="text-center mb-16" data-id="element-48">
            <span className="text-[#c9a227] font-bold tracking-[0.2em] text-sm uppercase mb-2 block" data-id="element-49">
              The Truth They're Hiding From You
            </span>
            <h2 className="text-4xl md:text-6xl font-bebas text-white mb-6" data-id="element-50">
              The Moment They Bought Your Debt For Pennies...
              <br data-id="element-51" />
              <span className="text-gray-500" data-id="element-52">They Lost The Upper Hand.</span>
            </h2>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="max-w-3xl mx-auto border border-[#c9a227] bg-[#0a0a0f] p-6 relative" data-id="element-53">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-[#0a0a0f] px-4 text-[#c9a227] text-xs font-bold uppercase tracking-widest" data-id="element-54">
                Classified Intel
              </div>
              <p className="text-lg text-gray-300" data-id="element-55">
                Debt collectors are bound by strict Federal Laws (FDCPA) that
                they <span className="text-white font-bold italic" data-id="element-56">HOPE</span>{' '}
                you never read. They are{' '}
                <span className="text-[#dc2626] font-bold" data-id="element-57">TERRIFIED</span> of
                someone who knows the Silence Code.
              </p>
            </motion.div>
          </div>

          <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-58">
            {[{
            val: '$0.04',
            label: 'What they paid for your $1,000 debt',
            icon: DollarSign
          }, {
            val: '$1,000',
            label: 'Federal penalty per FDCPA violation',
            icon: AlertTriangle,
            highlight: true
          }, {
            val: '48 hrs',
            label: 'Time to legally silence them',
            icon: CheckCircle
          }].map((stat, i) => <motion.div key={i} variants={fadeIn} className={`bg-[#111118] p-8 text-center border ${stat.highlight ? 'border-[#dc2626]/50 shadow-[0_0_20px_rgba(220,38,38,0.1)]' : 'border-gray-800'} relative group hover:border-[#c9a227] transition-colors duration-300`} data-id="element-59">
                <stat.icon className={`w-8 h-8 mx-auto mb-4 ${stat.highlight ? 'text-[#dc2626]' : 'text-gray-500 group-hover:text-[#c9a227]'}`} data-id="element-60" />
                <div className={`text-5xl font-bebas mb-2 ${stat.highlight ? 'text-[#dc2626]' : 'text-white'}`} data-id="element-61">
                  {stat.val}
                </div>
                <p className="text-sm text-gray-400 uppercase tracking-wide" data-id="element-62">
                  {stat.label}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </section>

      {/* 5. WHAT'S INSIDE SECTION */}
      <section className="py-24 px-4 bg-[#0a0a0f] relative" data-id="element-63">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10 pointer-events-none" data-id="element-64"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-65">
          <div className="text-center mb-16" data-id="element-66">
            <span className="text-[#c9a227] font-bold tracking-[0.2em] text-sm uppercase mb-2 block" data-id="element-67">
              Inside The 48-Hour Debt Freeze
            </span>
            <h2 className="text-5xl md:text-7xl font-bebas text-white" data-id="element-68">
              Your Complete Legal Arsenal
            </h2>
          </div>

          <div className="space-y-6" data-id="element-69">
            {[{
            title: 'The Kill Switch Template',
            desc: 'The exact certified-mail letter that legally bars them from ever calling your phone again. One send. Permanent silence.',
            icon: Mail
          }, {
            title: 'The 3-Phrase Phone Defense',
            desc: 'What to say if you accidentally pick up. Three sentences that make collectors hang up first — and never call back.',
            icon: Phone
          }, {
            title: 'The Validation Trap',
            desc: "Force them to prove they actually own the debt. Most can't. This single move stops 70% of collectors cold.",
            icon: FileText
          }, {
            title: 'The $1,000 Violation Log',
            desc: 'Turn their harassment into YOUR payday. Document every violation and file for federal damages.',
            icon: DollarSign
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-[#111118] border-t-2 border-[#c9a227] p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start hover:bg-[#16161f] transition-colors" data-id="element-70">
                <div className="bg-[#0a0a0f] p-4 rounded-sm border border-gray-800 shrink-0" data-id="element-71">
                  <item.icon className="w-8 h-8 text-[#c9a227]" data-id="element-72" />
                </div>
                <div data-id="element-73">
                  <div className="flex items-center gap-3 mb-2" data-id="element-74">
                    <span className="text-xs font-bold text-gray-600 border border-gray-700 px-2 py-0.5 rounded" data-id="element-75">
                      FILE 0{i + 1}
                    </span>
                    <h3 className="text-2xl font-bebas text-white tracking-wide" data-id="element-76">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-gray-400 leading-relaxed" data-id="element-77">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* 6. HEADLINE GALLERY SECTION */}
      <section className="py-20 px-4 bg-[#0f0f1a] border-t border-gray-900" data-id="element-78">
        <div className="max-w-5xl mx-auto" data-id="element-79">
          <h2 className="text-4xl md:text-6xl font-bebas text-center text-white mb-12" data-id="element-80">
            Why Negotiating Is A Trap
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-81">
            {[{
            bad: 'Negotiate payment plans',
            good: 'Invoke right to cease communication',
            desc: 'Negotiating admits the debt is yours. Silence protects your rights.'
          }, {
            bad: 'Answer their questions',
            good: 'Say nothing (3-phrase defense)',
            desc: "Information is ammunition. Don't give them any."
          }, {
            bad: 'Pay without proof',
            good: 'Demand debt validation first',
            desc: "If they can't prove it (most can't), you don't owe it."
          }].map((card, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-[#0a0a0f] border border-gray-800 p-6 relative" data-id="element-82">
                <div className="mb-6 pb-6 border-b border-gray-800" data-id="element-83">
                  <div className="flex items-center gap-2 text-[#dc2626] mb-2 font-bold text-sm uppercase" data-id="element-84">
                    <XCircle className="w-4 h-4" data-id="element-85" /> They want you to:
                  </div>
                  <p className="text-xl font-bebas text-gray-400" data-id="element-86">{card.bad}</p>
                </div>

                <div className="mb-4" data-id="element-87">
                  <div className="flex items-center gap-2 text-[#c9a227] mb-2 font-bold text-sm uppercase" data-id="element-88">
                    <CheckCircle className="w-4 h-4" data-id="element-89" /> The Law Says:
                  </div>
                  <p className="text-2xl font-bebas text-white" data-id="element-90">{card.good}</p>
                </div>

                <p className="text-sm text-gray-500 italic" data-id="element-91">{card.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* 7. PRICE + CTA SECTION */}
      <section id="pricing" className="py-24 px-4 bg-[#0a0a0f] relative overflow-hidden" data-id="element-92">
        {/* Background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#c9a227]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-93"></div>

        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-94">
          <div className="mb-10 p-4 bg-[#111118] border border-gray-800 inline-block rounded-sm" data-id="element-95">
            <p className="text-gray-400 text-sm md:text-base" data-id="element-96">
              A single FDCPA attorney consultation costs{' '}
              <span className="text-white font-bold" data-id="element-97">$300-$500/hour</span>.
              <br data-id="element-98" />A "late fee" on your account is{' '}
              <span className="text-white font-bold" data-id="element-99">$35+</span>.
            </p>
          </div>

          <div className="flex items-center justify-center gap-6 mb-4" data-id="element-100">
            <span className="text-4xl font-bebas text-gray-600 line-through decoration-[#dc2626] decoration-2" data-id="element-101">
              $31.95
            </span>
            <div className="flex flex-col items-start" data-id="element-102">
              <span className="bg-[#dc2626] text-white text-xs font-bold px-2 py-0.5 mb-1 tracking-widest uppercase" data-id="element-103">
                80% OFF
              </span>
              <span className="text-8xl font-bebas text-[#c9a227]" data-id="element-104">$6.39</span>
            </div>
          </div>

          <p className="text-gray-400 mb-10 uppercase tracking-widest text-sm" data-id="element-105">
            One-time payment · Instant access · No subscriptions
          </p>

          <motion.a href="#" onClick={handlePurchaseClick} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full md:w-auto md:inline-block bg-[#c9a227] text-black text-2xl md:text-3xl font-bebas py-6 px-16 rounded-sm shadow-[0_0_40px_rgba(201,162,39,0.3)] hover:shadow-[0_0_60px_rgba(201,162,39,0.5)] transition-all mb-8" data-id="element-106">
            GIVE ME THE SILENCE — $6.39
          </motion.a>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-gray-500" data-id="element-107">
            <span className="flex items-center gap-2" data-id="element-108">
              <Lock className="w-4 h-4" data-id="element-109" /> 256-bit Secure Checkout
            </span>
            <span className="flex items-center gap-2" data-id="element-110">
              <Mail className="w-4 h-4" data-id="element-111" /> Instant Email Delivery
            </span>
            <span className="flex items-center gap-2" data-id="element-112">
              <CheckCircle className="w-4 h-4" data-id="element-113" /> 30-Day Money Back Guarantee
            </span>
          </div>
        </div>
      </section>

      {/* 8. URGENCY CLOSE SECTION */}
      <section className="py-20 px-4 bg-gradient-to-b from-[#1a0505] to-[#0a0a0f] border-t border-[#dc2626]/20" data-id="element-114">
        <div className="max-w-4xl mx-auto text-center" data-id="element-115">
          <h2 className="text-5xl md:text-7xl font-bebas text-white mb-6" data-id="element-116">
            Your Phone Will Ring Again Tomorrow.
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-117">
            The only question is: will you have the legal shield to silence it?
            For $27 — less than the late fee they just added to your account —
            you can end the harassment today.
          </p>
          <a href="#pricing" className="text-[#c9a227] underline hover:text-white transition-colors font-bold uppercase tracking-widest" data-id="element-118">
            Get The Compliance Strike Kit Now
          </a>
        </div>
      </section>

      {/* 9. FOOTER */}
      <footer className="py-12 px-4 bg-[#050508] text-center border-t border-gray-900" data-id="element-119">
        <div className="max-w-4xl mx-auto" data-id="element-120">
          <p className="text-gray-600 text-sm mb-4" data-id="element-121">
            © {new Date().getFullYear()} 48-Hour Debt Freeze. All rights
            reserved.
          </p>
          <p className="text-gray-700 text-xs max-w-2xl mx-auto" data-id="element-122">
            DISCLAIMER: This product is for educational purposes only and does
            not constitute legal advice. We are not a law firm. If you need
            legal representation, please contact an attorney. Results may vary
            based on your specific situation.
          </p>
        </div>
      </footer>
    </div>;
}